import { createAsyncAction, createAction, ActionType } from 'typesafe-actions';
import 'isomorphic-fetch';
import { DataFetchingThunkAction } from '../../types';
import { ClubRegistrationError, ClubRegistrationStatus } from '../types';
import { getErrorCustomData } from '../../../../common/errors/CustomFetchApiError';
import { handleExistingUserClubRegistration } from '../actions';

export const resendDoiConfirmationActions = createAsyncAction(
    '@RESEND_DOI_CONFIRMATION/START',
    '@RESEND_DOI_CONFIRMATION/SUCCESS',
    '@RESEND_DOI_CONFIRMATION/FAILED'
)<undefined, String, ClubRegistrationError>();

export const apiResendDOIConfirmation = (isNewsletterSubscribed: boolean): DataFetchingThunkAction => async (
    dispatch,
    _,
    { apiService, logger }
) => {
    dispatch(resendDoiConfirmationActions.request());
    try {
        const result = await apiService.shopApi.resendDOIConfirmationEmail(isNewsletterSubscribed);
        if (result && result.success) {
            dispatch(resendDoiConfirmationActions.success(result.data));
            return;
        }

        throw result;
    } catch (err) {
        logger.error(err, { action: 'resendDoiConfirmation', ...getErrorCustomData(err) });
        dispatch(resendDoiConfirmationActions.failure(err));
    }
};

export const updateClubRegistrationStatus = createAction(
    '@CLUB_REGISTRATION_STATUS',
    action => (status?: ClubRegistrationStatus) => action(status)
);

export const apiUserExists = (
    email: string,
    password: string,
    nextRegistrationStep: () => void,
    tracking: () => void,
    existingUserMessage: string
    // eslint-disable-next-line max-params
): DataFetchingThunkAction => async (dispatch, _, { apiService, logger }) => {
    try {
        const result = await apiService.shopApi.userEmailExists(email);
        if (result && result.data && result.data.exists) {
            dispatch(handleExistingUserClubRegistration({ email, password }, existingUserMessage));
            return;
        }
        tracking();
        nextRegistrationStep();
        return;
    } catch (err) {
        logger.error(err, { action: 'apiUserExists', ...getErrorCustomData(err) });
    }
};

export type ResendDoiConfirmationActions = ActionType<typeof resendDoiConfirmationActions>;
export type ClubRegistrationActions = ResendDoiConfirmationActions | ActionType<typeof updateClubRegistrationStatus>;
